export enum DiscountType {
  PERCENTAGE = 'percentage',
  CURRENCY = 'currency',
}

export const discountTypes = [
  { id: DiscountType.PERCENTAGE, name: 'Porcentaje' },
  { id: DiscountType.CURRENCY, name: 'Moneda' },
];
